<app-navbar>
	<button class="btn btn-warning me-2" (click)="print()">
		<i class="fas fa-print"></i>
		Drukuj
	</button>
	<span class="btn btn-danger" onclick="window.close()"> <i class="fas fa-times"></i> Zamknij </span>
</app-navbar>

<ng-template #vehicleList let-vehicles="vehicles" let-displayField="displayField">
	@for (item of vehicles; track item.id; let last = $last) {
		{{ item[displayField] }}{{ !last ? ', ' : '' }}
	}
</ng-template>

<div class="container" *ngIf="documentType === 'departureCard'">
	<div class="row mb-2">
		<div class="col-4">
			<img src="/assets/logo.png" alt="OSKAR" />
		</div>
		<div class="col-8">
			<h4>KARTA WYJAZDU</h4>
		</div>
	</div>
	<div class="row mb-2">
		<div class="col border border-dark">
			<b>Nr pojazdu</b><br />
			<ng-container
				*ngTemplateOutlet="vehicleList; context: { vehicles: event?.mappedVehicles, displayField: 'name' }"
			></ng-container>
		</div>
		<div class="col border border-dark">
			<b>Nr rejestracyjny</b><br />
			<ng-container
				*ngTemplateOutlet="
					vehicleList;
					context: { vehicles: event?.mappedVehicles, displayField: 'registrationNumber' }
				"
			></ng-container>
		</div>
		<div class="col border border-dark"><b>Rodzaj wyjazdu</b><br />{{ event?.type }}</div>
		<div class="col border border-dark"><b>Organizator</b><br />{{ event?.category }}</div>
		<div class="col border border-dark"><b>Liczba osób</b><br />{{ event?.people }}</div>
	</div>
	<div class="row mb-2 border border-dark">
		<table class="table table-bordered">
			<tr *ngIf="event?.text_client">
				<th>Wynajmujący</th>
				<td><span [innerHTML]="event?.text_client"></span></td>
			</tr>
			<tr>
				<th>Cel wyjazdu</th>
				<td>{{ event?.name }}</td>
			</tr>
			<tr>
				<th>Kierowca opiekun</th>
				<td>{{ event?.drivers_senior }}</td>
			</tr>
			<tr *ngIf="event?.drivers_departure">
				<th>Kierowcy wyjazd</th>
				<td>{{ event?.drivers_departure }}</td>
			</tr>
			<tr *ngIf="event?.drivers_program">
				<th>Kierowcy program</th>
				<td>{{ event?.drivers_program }}</td>
			</tr>
			<tr *ngIf="event?.drivers_return">
				<th>Kierowcy powrót</th>
				<td>{{ event?.drivers_return }}</td>
			</tr>
			<tr *ngIf="event?.tourist_guides_departure">
				<th>Piloci wyjazd</th>
				<td>{{ event?.tourist_guides_departure }}</td>
			</tr>
			<tr *ngIf="event?.tourist_guides_program">
				<th>Piloci program</th>
				<td>{{ event?.tourist_guides_program }}</td>
			</tr>
			<tr *ngIf="event?.tourist_guides_return">
				<th>Piloci powrót</th>
				<td>{{ event?.tourist_guides_return }}</td>
			</tr>
			<tr *ngIf="event?.text_refueling">
				<th>Tankowania</th>
				<td><span [innerHTML]="event?.text_refueling"></span></td>
			</tr>
		</table>
	</div>
	<div class="row mb-2">
		<div class="col-3 border border-dark">
			<b>Odprawa</b><br />{{ event?.date_prepare | formatDateTime }}
			{{ event?.briefingPlace }}
		</div>
		<div class="col-3 border border-dark"><b>Wyjazd</b><br />{{ event?.date_from | formatDateTime }}</div>
		<div class="col-3 border border-dark">
			<b>Podstawienie</b><br />{{ event?.startDate | formatDateTime }} {{ event?.startPostCode }}
			{{ event?.startPlace }}
		</div>
		<div class="col-3 border border-dark"><b>Powrót</b><br />{{ event?.date_to | formatDateTime }}</div>
	</div>
	<div class="row mb-2 border border-dark" *ngIf="event?.text_program">
		<b>Plan wyjazdu:</b> <span [innerHTML]="event?.text_program"></span>
	</div>
	<div class="row mb-2 border border-dark" *ngIf="event?.text_departure">
		<b>Trasa wyjazd:</b><span [innerHTML]="event?.text_departure"></span>
	</div>
	<div class="row mb-2 border border-dark" *ngIf="event?.text_return">
		<b>Trasa powrót:</b><span [innerHTML]="event?.text_return"></span>
	</div>
	<div class="row mb-2 border border-dark">
		<b>Info o kierowcach:</b>
		<span [innerHTML]="event?.text_drivers"></span>
	</div>
	<div class="row mb-2 border border-dark" *ngIf="event?.text_hotel">
		<b>Info o hotelach:</b> <span [innerHTML]="event?.text_hotel"></span>
	</div>
	<div class="row mb-2 border border-dark" *ngIf="event?.text_hotel">
		<b>Uwagi:</b> <span [innerHTML]="event?.text_hotel"></span>
	</div>
</div>

<div class="container" *ngIf="documentType === 'transportBriefing'">
	<div class="row mb-2">
		<div class="col-4">
			<br /><br />
			<img src="/assets/oskartransport.png" alt="OSKAR" />
		</div>
		<div class="col-8">
			<div class="row">
				<div class="col-12">
					PTU OSKAR TRANS Sp. z o. o.<br />
					ul. Plac Wolności 2/5, 61-738 Poznań
				</div>
				<div class="col-6">
					tel. (061) 850 48 45<br />
					NIP 778-146-13-94
				</div>
				<div class="col-6">
					tel. alarmowy 664746815<br />
					REGON 301012668
				</div>
				<div class="col-12">
					<u>Konto: Alior Bank 26 2490 0005 0000 4520 2334 2019</u>
				</div>
			</div>
		</div>
	</div>
	<div class="row">
		<div class="col-8 offset-4">
			<h4>Protokół przewozu</h4>
		</div>
	</div>
	<div class="row dark">
		<div class="col border border-dark text-center">
			<b
				>Numer rejestracyjny pojazdu:
				<ng-container
					*ngTemplateOutlet="
						vehicleList;
						context: { vehicles: event?.mappedVehicles, displayField: 'registrationNumber' }
					"
				></ng-container>
			</b>
		</div>
	</div>

	<div class="row mb-2">
		<table class="table table-bordered border-dark">
			<tr>
				<th class="align-top">Organizator / Pilot</th>
				<td colspan="2">
					<span class="d-block" *ngIf="event?.organizer">
						{{ event?.organizer }}
					</span>
					<span class="d-block" *ngIf="event?.tourist_guides_departure">
						{{ event?.tourist_guides_departure }}
					</span>
					<span class="d-block" *ngIf="event?.tourist_guides_program">
						{{ event?.tourist_guides_program }}
					</span>
					<span class="d-block" *ngIf="event?.tourist_guides_return">
						{{ event?.tourist_guides_return }}
					</span>
				</td>
			</tr>
			<tr>
				<th class="align-top">Kierowcy</th>
				<td colspan="2">
					<span class="d-block" *ngIf="event?.drivers_senior">
						{{ event?.drivers_senior }}
					</span>
					<span class="d-block" *ngIf="event?.drivers_departure">
						{{ event?.drivers_departure }}
					</span>
					<span class="d-block" *ngIf="event?.drivers_program">
						{{ event?.drivers_program }}
					</span>
					<span class="d-block" *ngIf="event?.drivers_return">
						{{ event?.drivers_return }}
					</span>
				</td>
			</tr>
			<tr>
				<th class="align-top">Trasa Przewozu</th>
				<td colspan="2" [innerHTML]="event?.text_departure"></td>
			</tr>
		</table>
	</div>
	<div style="break-after: page"></div>
	<div class="row mb-2">
		<div class="col-8 offset-4">
			<h6>STAN PRZY PODJĘCIU GRUPY</h6>
		</div>
		<table class="table table-bordered border-dark">
			<colgroup>
				<col style="width: 65px" />
				<col style="width: 300px" />
			</colgroup>
			<tr>
				<td class="align-items-center text-center" style="border: 1px solid #000">
					Miejscowość, data, godzina
				</td>
				<td style="border: 1px solid #000"></td>
			</tr>
			<tr>
				<td class="align-items-center text-center" style="border: 1px solid #000">Stan licznika</td>
				<td style="border: 1px solid #000"></td>
			</tr>
		</table>
	</div>
	<div class="row mb-2">
		<div class="col-8 offset-1">
			<h6>Ja, ................................................................., niżej podpisany</h6>
			<small class="col-8 offset-3"><i>imię i nazwisko</i></small>
		</div>
	</div>
	<div class="row mb-2">
		<div class="col-8 offset-1 text-center align-items-center" style="display: flex">
			<span class="square"></span>
			nie zgłaszam uwag do stanu technicznego autokaru,
		</div>
		<div class="col-8 offset-1 text-center align-items-center" style="display: flex">
			<span class="square"></span>
			zgłaszam uwagi:
		</div>
	</div>
	<div class="row mb-2">
		<div class="col-8">
			<h6>Szczegółowy opis uszkodzeń:</h6>
		</div>
	</div>
	<div class="row mb-2">
		<table class="table table-bordered border-dark">
			<colgroup>
				<col style="width: 65px" />
				<col style="width: 300px" />
			</colgroup>
			<tr>
				<td class="align-items-center text-center" style="border: 1px solid #000">
					system multimedialny<br />(uszkodzenia, kradzież itp.)
				</td>
				<td style="border: 1px solid #000">
					<span class="d-block"> <br /><br /><br /> </span>
				</td>
			</tr>
			<tr>
				<td class="align-items-center text-center" style="border: 1px solid #000">inne</td>
				<td style="border: 1px solid #000">
					<span class="d-block"> <br /><br /><br /> </span>
				</td>
			</tr>
			<tr>
				<td class="align-items-center text-center" style="border: 1px solid #000">dodatkowe uwagi</td>
				<td style="border: 1px solid #000">
					<span class="d-block"> <br /><br /><br /> </span>
				</td>
			</tr>
		</table>
	</div>
	<div class="row mb-2">
		<div class="text-center col-5">
			<span>.........................................................................</span><br />
			<small><i>podpis kierowcy</i></small>
		</div>
		<div class="col-1 me-5"></div>
		<div class="text-center col-5">
			<span>.........................................................................</span><br />
			<small><i>podpis pilota/opiekuna grupy</i></small>
		</div>
	</div>
	<div style="break-after: page"></div>
	<div class="row mb-2 mt-5">
		<div class="col-8 offset-4">
			<h6>STAN PRZY ODSTAWIENIU GRUPY:</h6>
		</div>
		<table class="table table-bordered border-dark">
			<colgroup>
				<col style="width: 65px" />
				<col style="width: 300px" />
			</colgroup>
			<tr>
				<td class="align-items-center text-center" style="border: 1px solid #000">
					Miejscowość, data, godzina
				</td>
				<td style="border: 1px solid #000"></td>
			</tr>
			<tr>
				<td class="align-items-center text-center" style="border: 1px solid #000">Stan licznika</td>
				<td style="border: 1px solid #000"></td>
			</tr>
		</table>
	</div>
	<div class="row mb-2">
		<div class="col-8 offset-1">
			<h6>Ja, ................................................................., niżej podpisany</h6>
			<small class="col-8 offset-3"><i>imię i nazwisko</i></small>
		</div>
	</div>
	<div class="row mb-2">
		<div class="col-8 offset-1 text-center align-items-center" style="display: flex">
			<span class="square"></span>
			nie zgłaszam uwag do stanu technicznego autokaru,
		</div>
		<div class="col-8 offset-1 text-center align-items-center" style="display: flex">
			<span class="square"></span>
			zgłaszam uwagi:
		</div>
	</div>
	<div class="row mb-2">
		<div class="col-8">
			<h6>Szczegółowy opis uszkodzeń:</h6>
		</div>
	</div>
	<div class="row mb-2">
		<table class="table table-bordered border-dark">
			<colgroup>
				<col style="width: 65px" />
				<col style="width: 300px" />
			</colgroup>
			<tr>
				<td class="align-items-center text-center" style="border: 1px solid #000">
					system multimedialny<br />(uszkodzenia, kradzież itp.)
				</td>
				<td style="border: 1px solid #000">
					<span class="d-block"> <br /><br /><br /> </span>
				</td>
			</tr>
			<tr>
				<td class="align-items-center text-center" style="border: 1px solid #000">inne</td>
				<td style="border: 1px solid #000">
					<span class="d-block"> <br /><br /><br /> </span>
				</td>
			</tr>
			<tr>
				<td class="align-items-center text-center" style="border: 1px solid #000">dodatkowe uwagi</td>
				<td style="border: 1px solid #000">
					<span class="d-block"> <br /><br /><br /> </span>
				</td>
			</tr>
		</table>
	</div>
	<div class="row mb-2">
		<div class="text-center col-5">
			<span>.........................................................................</span><br />
			<small><i>podpis kierowcy</i></small>
		</div>
		<div class="col-1 me-5"></div>
		<div class="text-center col-5">
			<span>.........................................................................</span><br />
			<small><i>podpis pilota/opiekuna grupy</i></small>
		</div>
	</div>
</div>

<!-- <div class="container" *ngIf="documentType == 'transportBriefing'">
	<div class="row mb-2">
		<div class="col-4">
			<br><br>
			<img src="/assets/oskartransport.png" alt="OSKAR">
		</div>
		<div class="col-8">
			<div class="row">
				<div class="col-12">
					PTU OSKAR TRANS Sp. z o. o.<br>
					ul. Plac Wolności 2/5, 61-738 Poznań
				</div>
				<div class="col-6">
					tel. (061) 850 48 45<br>
					NIP 778-146-13-94
				</div>
				<div class="col-6">
					tel. alarmowy 664746815<br>
					REGON 301012668
				</div>
				<div class="col-12">
					<u>Konto: Alior Bank 26 2490 0005 0000 4520 2334 2019</u>
				</div>
			</div>
		</div>
	</div>
	<div class="row">
		<div class="col-8 offset-4">
			<h4>Protokół przewozu</h4>
		</div>
	</div>
	<div class="row dark">
		<div class="col border border-dark text-center">
			<b>Numer rejestracyjny pojazdu: {{ event?.vehicle?.registrationNumber }}</b>
		</div>
	</div>

	<div class="row mb-2">
		<table class="table table-bordered border-dark">
			<tr>
				<th class="align-top">Organizator / Pilot</th>
				<td colspan="2">
					<span class="d-block" *ngIf="event?.organizer">
						{{ event?.organizer }}
					</span>
					<span class="d-block" *ngIf="event?.tourist_guides_departure">
						{{ event?.tourist_guides_departure }}
					</span>
					<span class="d-block" *ngIf="event?.tourist_guides_program">
						{{ event?.tourist_guides_program }}
					</span>
					<span class="d-block" *ngIf="event?.tourist_guides_return">
						{{ event?.tourist_guides_return }}
					</span>
				</td>
			</tr>
			<tr>
				<th class="align-top">Kierowcy</th>
				<td colspan="2">
					<span class="d-block" *ngIf="event?.drivers_senior">
						{{ event?.drivers_senior }}
					</span>
					<span class="d-block" *ngIf="event?.drivers_departure">
						{{ event?.drivers_departure }}
					</span>
					<span class="d-block" *ngIf="event?.drivers_program">
						{{ event?.drivers_program }}
					</span>
					<span class="d-block" *ngIf="event?.drivers_return">
						{{ event?.drivers_return }}
					</span>
				</td>
			</tr>
			<tr>
				<th class="align-top">Trasa Przewozu</th>
				<td colspan="2" [innerHTML]="event?.text_departure"></td>
			</tr>
			<tr>
				<th colspan="2" class="align-top">Stan licznika - Podjęcie grupy</th>
				<td>&nbsp;</td>
			</tr>
			<tr>
				<th colspan="2" class="align-top">Stan licznika - Odstawienie grupy</th>
				<td>&nbsp;</td>
			</tr>
			<tr>
				<th class="align-top text-center" colspan="3">Stwierdzone uszkodzenia autokaru:</th>
			</tr>
			<tr>
				<th class="align-top">System multimedialny<br>(uszkodzenia, kradzież itp.)</th>
				<td class="text-center border border-dark">Stan - Podjęcie grupy<br><br><br><br><br></td>
				<td class="text-center">Stan - Odstawienie grupy<br><br><br><br><br></td>
			</tr>
			<tr>
				<th class="align-top">Inne</th>
				<td class="border border-dark"><br><br><br><br><br></td>
				<td><br><br><br><br><br></td>
			</tr>
			<tr>
				<th class="align-top" colspan="3">Uwagi Organizatora/Pilota</th>
			</tr>
			<tr>
				<td colspan="3"><br><br><br><br><br></td>
			</tr>
			<tr>
				<th colspan="2" class="align-top">Data sporządzenia protokolu</th>
				<td></td>
			</tr>
			<tr>
				<th colspan="2" class="align-top">Podpis Kierowcy</th>
				<td></td>
			</tr>
			<tr>
				<th colspan="2" class="align-top">Podpis Organizatora/Pilota</th>
				<td></td>
			</tr>
		</table>
	</div>
</div> -->

<div class="container container-1" *ngIf="documentType === 'transportCheckOut'">
	<div class="row mb-2">
		<div class="align-items-center text-center">
			<img src="/assets/logo.png" alt="OSKAR" />
		</div>
	</div>
	<div class="row dark">
		<div class="col border border-dark text-center">
			<b>DO UZUPEŁNIENIA W BIURZE</b>
		</div>
	</div>
	<div class="row mb-2">
		<table class="table table-bordered border-dark">
			<tr>
				<td class="align-top border border-dark">&nbsp;DATA:</td>
				<td colspan="2"></td>
			</tr>
			<tr>
				<td class="align-top border border-dark">&nbsp;NUMER POJAZDU</td>
				<td colspan="2" class="text-center">
					<b
						><ng-container
							*ngTemplateOutlet="
								vehicleList;
								context: { vehicles: event?.mappedVehicles, displayField: 'name' }
							"
						></ng-container>
					</b>
				</td>
			</tr>
			<tr>
				<td class="align-top border border-dark">&nbsp;Pilot / Organizator:<br /></td>

				<td class="align-top text-center border border-dark">&nbsp;Kto:<br /><br /><br /></td>
				<td class="align-top text-center">&nbsp;Podpis osoby z organizacji:<br /><br /><br /></td>
			</tr>
			<tr>
				<td class="align-top border border-dark">&nbsp;KIEROWCY NA DYŻURZE</td>
				<td colspan="2"></td>
			</tr>
			<tr>
				<td class="align-top border border-dark">&nbsp;UMOWA O PRACĘ LUB O DZIEŁO</td>
				<td colspan="2"></td>
			</tr>
			<tr>
				<td class="align-top border border-dark">&nbsp;PIENIĄDZE NA WYJAZD(komu/kwota/waluta):</td>
				<td colspan="2"></td>
			</tr>
			<tr>
				<td class="align-top border border-dark">&nbsp;DODATKOWE PROŚBY KLIENTA:</td>
				<td colspan="2"></td>
			</tr>
			<tr>
				<td class="align-top border border-dark">&nbsp;PŁATNOŚĆ (dot. wynajmów):</td>
				<td colspan="2"></td>
			</tr>
			<tr>
				<td class="align-top border border-dark">
					&nbsp;KONTAKT OPIEKUNA KLIENTA<br />&nbsp; Z ORGANIZATOREM WYJAZDU:
				</td>
				<td colspan="2">
					&nbsp;Ilość osób:<br />&nbsp;Miejsce i godzina podstawienia:<br />&nbsp;Szczególne wyznaczone
					trasy:<br />
				</td>
			</tr>
			<tr>
				<th class="text-center align-top" colspan="3">&nbsp;ODPRAWA - RUMIANEK:</th>
			</tr>
			<tr>
				<td class="align-top border border-dark">&nbsp;PLAN WYJAZDU PRZKAZANY KIEROWCY:</td>
				<td colspan="2"></td>
			</tr>
			<tr>
				<td class="align-top border border-dark">
					&nbsp;BADANIE PROMIERZEM TRZEŹWOŚCI/<br />&nbsp;SPRAWDZENIE PRAWA JAZDY:
				</td>
				<td colspan="2"></td>
			</tr>
			<tr>
				<td class="align-top border border-dark">&nbsp;SCZYTANIE KARTY KIEROWCY:</td>
				<td colspan="2"></td>
			</tr>
			<tr>
				<td class="align-top border border-dark">&nbsp;PROTOKÓŁ WARSZTATU SPRAWNOŚCI AUTA:</td>
				<td colspan="2"></td>
			</tr>
			<tr>
				<td class="text-left border border-dark">&nbsp;DOKUMENTY:</td>
				<td class="text-left">
					&nbsp;Dowód rejestracyjny:<br />
					&nbsp;Ubezpieczenie:<br />
					&nbsp;Karty(Flota/Alior):<br />
					&nbsp;Zielona Kart:<br />
					&nbsp;Licencja:<br />
					&nbsp;Steuery:<br />
					&nbsp;Leasing:<br />
					&nbsp;Winieta węgierska:<br />
					&nbsp;Formularz/Interbus:<br />
					&nbsp;Papier - tacho/tarczki(zapas):
				</td>
			</tr>
			<tr>
				<td class="text-left border border-dark">&nbsp;AKCESORIA:</td>
				<td class="text-left">
					&nbsp;Tablica "dzieci":<br />
					&nbsp;Filmy:<br />
					&nbsp;Słuchawki:<br />
					&nbsp;Router Wi-Fi:
				</td>
			</tr>
			<tr>
				<td class="align-top border border-dark">&nbsp;TECZKA TURYSTYCZNA:</td>
				<td colspan="2"></td>
			</tr>
			<tr>
				<td class="align-top border border-dark">&nbsp;TOURGUIDE TGS:</td>
				<td colspan="2"></td>
			</tr>
			<tr>
				<td class="align-top border border-dark">&nbsp;PAKIET KOMFORT:</td>
				<td colspan="2"></td>
			</tr>
			<tr>
				<td class="text-left border border-dark">&nbsp;CZYSTOŚĆ AUTOKARU:</td>
				<td colspan="2" class="text-left">
					&nbsp;Wewnątrz:<br />
					&nbsp;Z zewnątrz:<br />
				</td>
			</tr>
			<tr>
				<td class="align-top border border-dark">&nbsp;STRÓJ SŁUŻBOWY:</td>
				<td colspan="2"></td>
			</tr>
			<tr class="border-white">
				<td colspan="2"></td>
				<td class="text-center"><br /><br />...............................................</td>
			</tr>
			<tr class="border-white">
				<td colspan="2"></td>
				<td class="text-center">Podpis koordynatora</td>
			</tr>
		</table>
	</div>
</div>

<div class="container container-1" *ngIf="documentType === 'top'">
	<div class="text-center">
		<h1 class="mb-5">
			<ng-container
				*ngTemplateOutlet="vehicleList; context: { vehicles: event?.mappedVehicles, displayField: 'name' }"
			></ng-container>
		</h1>
		<h1 class="mb-5">{{ event?.name }}</h1>
		<h1 class="mb-5">{{ event?.date_from | formatDateTime }} - {{ event?.date_to | formatDateTime }}</h1>
	</div>
	<div class="text-center ms-auto me-auto" style="width: 60%">
		<h2 *ngIf="event?.drivers_departure">Wyjazd</h2>
		<h2 class="mb-5">{{ event?.drivers_departure }}</h2>
		<h2 *ngIf="event?.drivers_program">Program</h2>
		<h2 class="mb-5 ms-auto me-auto">{{ event?.drivers_program }}</h2>
		<h2 *ngIf="event?.drivers_return">Powrót</h2>
		<h2>{{ event?.drivers_return }}</h2>
	</div>
</div>
